module.exports = __webpack_public_path__ + "static/media/afb_code.6dadd135.png";